import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
// import { Link } from 'react-router-dom'
// import { Row, Col, Modal, ModalHeader, ModalBody, ModalFooter, Button} from 'reactstrap'
import { send } from '../../modules/media'
import { getAllStructures, getVisibleStructures } from '../../modules/structures'
import { withRouter } from 'react-router'

import './calculations.css'
import 'font-awesome/css/font-awesome.css'

import {
//   Badge,
//   Row,
//   Col,
  Progress,
//   Dropdown,
//   DropdownToggle,
//   DropdownMenu,
//   DropdownItem,
//   Card,
//   CardHeader,
//   CardBlock,
//   CardFooter,
//   CardTitle,
//   Button,
//   ButtonToolbar,
//   ButtonGroup,
//   ButtonDropdown,
//   Label,
//   Input,
  Table
} from "reactstrap";








class Calculations extends Component {

  render() {
    // const { props } = this;
    return (
      <div className="home container-fluid">
        <div className="animated fadeIn mt-4">
          <Table hover responsive className="table-outline mb-0 d-none d-sm-table">
                <thead className="thead-default bg-gray-500 text-white">
                <tr>
                  <th>Structure</th>
                  <th className="text-center">Project</th>
                  <th>Temps</th>
                  <th className="text-center">Status</th>
                  <th>Calculation type</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>
                    <div>Yiorgos Avraamu</div>
                    <div className="small text-muted">
                      <span>New</span> | Registered: Jan 1, 2015
                    </div>
                  </td>
                  <td className="text-center">
                  </td>
                  <td>
                    <div className="clearfix">
                      <div className="float-left">
                        <strong>50%</strong>
                      </div>
                      <div className="float-right">
                        <small className="text-muted">Jun 11, 2015 - Jul 10, 2015</small>
                      </div>
                    </div>
                    <Progress className="progress-xs" color="success" value="50"/>
                  </td>
                  <td className="text-center">
                    <span className="avatar-status badge-success"></span>
                  </td>
                  <td>
                    <div className="small text-muted">Last login</div>
                    <strong>10 sec ago</strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div>Avram Tarasios</div>
                    <div className="small text-muted">
                      <span>Recurring</span> | Registered: Jan 1, 2015
                    </div>
                  </td>
                  <td className="text-center">
                  </td>
                  <td>
                    <div className="clearfix">
                      <div className="float-left">
                        <strong>10%</strong>
                      </div>
                      <div className="float-right">
                        <small className="text-muted">Jun 11, 2015 - Jul 10, 2015</small>
                      </div>
                    </div>
                    <Progress className="progress-xs" color="info" value="10"/>
                  </td>
                  <td className="text-center">
                    <span className="avatar-status badge-danger"></span>
                  </td>
                  <td>
                    <div className="small text-muted">Last login</div>
                    <strong>5 minutes ago</strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div>Quintin Ed</div>
                    <div className="small text-muted">
                      <span>New</span> | Registered: Jan 1, 2015
                    </div>
                  </td>
                  <td className="text-center">
                  </td>
                  <td>
                    <div className="clearfix">
                      <div className="float-left">
                        <strong>74%</strong>
                      </div>
                      <div className="float-right">
                        <small className="text-muted">Jun 11, 2015 - Jul 10, 2015</small>
                      </div>
                    </div>
                    <Progress className="progress-xs" color="warning" value="74"/>
                  </td>
                  <td className="text-center">
                    <span className="avatar-status badge-warning"></span>
                  </td>
                  <td>
                    <div className="small text-muted">Last login</div>
                    <strong>1 hour ago</strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div>Enéas Kwadwo</div>
                    <div className="small text-muted">
                      <span>New</span> | Registered: Jan 1, 2015
                    </div>
                  </td>
                  <td className="text-center">
                  </td>
                  <td>
                    <div className="clearfix">
                      <div className="float-left">
                        <strong>98%</strong>
                      </div>
                      <div className="float-right">
                        <small className="text-muted">Jun 11, 2015 - Jul 10, 2015</small>
                      </div>
                    </div>
                    <Progress className="progress-xs" color="danger" value="98"/>
                  </td>
                  <td className="text-center">
                    <span className="avatar-status badge-secondary"></span>
                  </td>
                  <td>
                    <div className="small text-muted">Last login</div>
                    <strong>Last month</strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div>Agapetus Tadeáš</div>
                    <div className="small text-muted">
                      <span>New</span> | Registered: Jan 1, 2015
                    </div>
                  </td>
                  <td className="text-center">
                  </td>
                  <td>
                    <div className="clearfix">
                      <div className="float-left">
                        <strong>22%</strong>
                      </div>
                      <div className="float-right">
                        <small className="text-muted">Jun 11, 2015 - Jul 10, 2015</small>
                      </div>
                    </div>
                    <Progress className="progress-xs" color="info" value="22"/>
                  </td>
                  <td className="text-center">
                    <span className="avatar-status badge-success"></span>
                  </td>
                  <td>
                    <div className="small text-muted">Last login</div>
                    <strong>Last week</strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div>Friderik Dávid</div>
                    <div className="small text-muted">
                      <span>New</span> | Registered: Jan 1, 2015
                    </div>
                  </td>
                  <td className="text-center">
                  </td>
                  <td>
                    <div className="clearfix">
                      <div className="float-left">
                        <strong>43%</strong>
                      </div>
                      <div className="float-right">
                        <small className="text-muted">Jun 11, 2015 - Jul 10, 2015</small>
                      </div>
                    </div>
                    <Progress className="progress-xs" color="success" value="43"/>
                  </td>
                  <td className="text-center">
                    <span className="avatar-status badge-danger"></span>
                  </td>
                  <td>
                    <div className="small text-muted">Last login</div>
                    <strong>Yesterday</strong>
                  </td>
                </tr>
                </tbody>
              </Table>
        </div>
    </div>
    )}
}

const mapStateToProps = state => {
  return ({
    ...state.user,
    structures: getVisibleStructures(state.structures)
  })
}

const mapDispatchToProps = dispatch => bindActionCreators({
  send,
  getAllStructures
}, dispatch)

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(Calculations))



// WEBPACK FOOTER //
// ./src/containers/calculations/index.js